import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Link, useLocation, useNavigate } from 'react-router-dom'
import './PaymentPage.css'
import loadgif from '../../Resources/loading2.gif'
import BASE_URL from '../../constant';



function PaymentPage() {
  const location = useLocation();
  const seatData = location.state;
  const navigate = useNavigate();

  const [seatArr, setSeatArr] = useState([]);
  const [movieData, setMovieData] = useState({})
  const [theatreData, setTheatreData] = useState({});
  const [errmsg, setErrorMessage] = useState("");
  const [payClicked, setPayClicked] = useState(false);

  const userData = JSON.parse(localStorage.getItem('userData'))

  const [data, setData] = useState({
    email : userData && userData.email,
    phone : userData && userData.phone,
  })

  let msgStyle = {
    display : errmsg ? "flex" : "none"
  }

  useEffect(()=>{
    setSeatArr([...seatData.seatsArr]);
    axios.get(`${BASE_URL}/bookmyshow/api/v1/movie/${seatData.movieId}`)
    .then(res => {
        setMovieData(res.data);
    })
    .catch(err => console.error(err));

    axios.get(`${BASE_URL}/bookmyshow/api/v1/theatre/${seatData.theatreId}`)
    .then(res => {
        setTheatreData(res.data);
    })
    .catch(err => console.error(err));
  },[seatData])
  
  let str = seatArr.join(', ');

  const handleSubmit = (e)=>{
    e.preventDefault();
    if(userData){
      axios.post(`${BASE_URL}/bookmyshow/api/v1/payment`,{
        email : data.email,
        phone : data.phone,
        seatsArr : [...seatArr],
        movieName : movieData.name,
        theatreName : theatreData.name,
        theatreId : theatreData._id,
        movieId : movieData._id,
        price : seatData.seatPrice+60,
        date : seatData.date,
        time : seatData.movieTime
      }).then(res => console.log(res.data))
      .catch(err => console.log(err.message));
      setPayClicked(true);

      setTimeout(() => {
        navigate(`/`)
      }, 4000);

    }else{
      setErrorMessage("Please login to do further payment.");
      setTimeout(() => {
        setErrorMessage("")
      }, 5000);
    }
  }

  const handleChange =(e)=>{
    const {name, value} = e.target;
    setData( {
      ...data,
      [name] : value
    })

  }

  return (
    <>
    {(payClicked) ? 
    <div className='gifContainer'>
    <img src={loadgif} alt="Loading..." /><div>Some payment processing simulation happening ...</div>
  </div> : 
  <div className='paymentCont'>
      <Link to={"/theatre-list/" + seatData.movieId}>
        <button className="backBtn">
          <i className='fa-solid fa-arrow-left-long'></i>
        </button>
      </Link>

      <form className="paymentForm">
      
      <div className="logalertmsg paylogmsg" style={msgStyle} >
        <span className="msgtext" >
        <i className="fa-solid fa-circle-exclamation"></i> &nbsp; &nbsp; {
            errmsg
          }
        </span>
        <span className="close-btn" onClick={()=>{setErrorMessage('')}}>×</span>
        <span className="line"></span>
      </div>

      <div className="mInfo">
        <div className="movieName">{movieData.name}</div>
        <div className="theatreInfo">
          {theatreData.name} &nbsp; | &nbsp; {seatData.movieTime} &nbsp; | &nbsp; {seatData.date}
        </div>
      </div>

      <div className="flex ubox">

        <div className="nfieldval emailfield">
          <span> <i className='fa-solid fa-ticket'></i> Enter your email</span>
          <input type="email" onChange={handleChange} value={data.email} name='email' placeholder='We will email your ticket' className="tel-input"/>
        </div>
        <div className="nfieldval">
          <span> <i className='fa-solid fa-phone'></i> Phone no.</span>
          <input type="tel" onChange={handleChange} value={data.phone} name='phone' className="tel-input"/>
        </div>

      </div>
      
      <div className="fieldval">
        <div className="tag">Seats ({seatArr.length})</div>
        <div className="fvalue"><input type="text" disabled={true} value={str} /></div>
      </div>
      
      <div className="fieldval">
        <div className="tag">Price</div>
        <div className="fvalue">₹ {seatData.seatPrice}</div>
      </div>
      
      <div className="fieldval">
        <div className="tag">Convinience Charges </div>
        <div className="fvalue">₹ 60</div>
      </div>
     
      <div className="payBtnContainer">
        <div className="priceField">
          Total Price - ₹ {seatData.seatPrice + 60}
        </div>
        <button className="payBtn" onClick={handleSubmit}> Pay &nbsp; ₹{seatData.seatPrice + 60}</button>
      </div>  

    </form>

    </div>}
    </>
  )
}

export default PaymentPage
